export const ApplicationConstant = {
    ApplicationID : 25,
    clientId : 15,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
